import { createAction } from 'redux-actions';

const AUTO_SCROLL_ON = 'AUTO_SCROLL_ON';
const AUTO_SCROLL_OFF = 'AUTO_SCROLL_OFF';

export const autoScrollOn = createAction(AUTO_SCROLL_ON);
export const autoScrollOff = createAction(AUTO_SCROLL_OFF);
export const isAutoScrollOn = (state) => state.autoScrollReducer.isAutoScrollEnabled;

const initialState = {
    isAutoScrollEnabled: false
};

const autoScrollReducer = (state = initialState, action) => {
    switch(action.type) {
        case AUTO_SCROLL_ON : {
            return { isAutoScrollEnabled: true };
        }
        case AUTO_SCROLL_OFF : {
            return { isAutoScrollEnabled: false };
        }
        default: {
            return state;
        }
    }
};

export default autoScrollReducer;


// WEBPACK FOOTER //
// ./src/reducers/autoScrollReducer.js